import React, { useContext } from "react";
import StaticContent from "../../../context/ContentContext";

const MobileBalance = () => {
  const { userData, storeData } = useContext(StaticContent)
  return (
    <div style={{ position: 'relative'}}>
      <div style={{ height: '26px', textAlign: 'center' }}>
      {userData && storeData?.data?.storeType === 'Balance' ? <b><span style={{ fontSize: '15px' }}>{`Balance: $${userData?.config?.balance ? userData?.config?.balance : '0'}`}</span></b> : <span />}
      </div>
    </div>
  );
};

export default MobileBalance;
